import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Button } from '@mui/material'
import { useAuthContext } from 'App/Auth'

import TwoRowErrorPage from 'shared/ErrorPages/TwoRowErrorPage'
import useStyles from './TwoRowErrorPage.style'

const propTypes = { message: PropTypes.string.isRequired }

const ErrorViewWithLogout = ({ message }) => {
    const { t } = useTranslation()
    const classes = useStyles()
    const { logout } = useAuthContext()

    const handleLogoutClick = useCallback(() => {
        logout()
    }, [logout])

    return (
        <TwoRowErrorPage
            message={message}
            iconPath="skycenter/crash_robot.svg"
            iconAlt="logo"
        >
            <Button
                className={classes.button}
                onClick={handleLogoutClick}
            >
                {t('LOGOUT')}
            </Button>
        </TwoRowErrorPage>
    )
}

ErrorViewWithLogout.propTypes = propTypes

export default ErrorViewWithLogout
